exports.components = {
  "component---src-created-detail-jsx": () => import("./../../../src/created/_detail.jsx" /* webpackChunkName: "component---src-created-detail-jsx" */),
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-list-jsx": () => import("./../../../src/pages/list.jsx" /* webpackChunkName: "component---src-pages-list-jsx" */)
}

